import { StorageManager } from '@funtech-int/web-toolkit';

const PREFERRED_USER_VIDEO_QUALITY_KEY = 'preferredUserVideoQuality';
const DEFAULT_PREFERRED_VIDEO_QUALITY = 1280;

export function getPreferredUserVideoQuality(storage: StorageManager): number | undefined {
    const preferredUserVideoQuality = Number(storage.local.get(PREFERRED_USER_VIDEO_QUALITY_KEY));

    return preferredUserVideoQuality && !Number.isNaN(preferredUserVideoQuality)
        ? preferredUserVideoQuality
        : DEFAULT_PREFERRED_VIDEO_QUALITY;
}
export function setPreferredUserVideoQuality(
    storage: StorageManager,
    videoQuality: number | undefined
) {
    if (videoQuality) {
        storage.local.set(PREFERRED_USER_VIDEO_QUALITY_KEY, videoQuality.toString());
    } else {
        storage.local.remove(PREFERRED_USER_VIDEO_QUALITY_KEY);
    }
}
